import React, { CSSProperties, useRef, useState } from 'react';

import './SwipeButton.css';

interface Props {
  onSwipeFinish: () => void;
  buttonText: string;
}

type ValueAsNumberExtension = { target: { valueAsNumber?: number } };
type InteractionEndEvent =
  | (React.MouseEvent<HTMLInputElement, MouseEvent> & ValueAsNumberExtension)
  | (React.TouchEvent<HTMLInputElement> & ValueAsNumberExtension);

export function SwipeButton({ onSwipeFinish, buttonText }: Props): JSX.Element {
  const [val, setVal] = useState(0);
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const clearIntervalCustom = (): void => {
    intervalId.current && clearInterval(intervalId.current);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.valueAsNumber === 100) {
      setVal(100);
      clearIntervalCustom();
      onSwipeFinish();
    }
    setVal(e.target.valueAsNumber);
  };

  const handleInteractionEnd = (e: InteractionEndEvent): void => {
    if (e.target.valueAsNumber === 100) {
      return;
    }
    intervalId.current = setInterval(function () {
      setVal((currentVal) => {
        if (+currentVal > 0) {
          return +currentVal - 2;
        }
        return 0;
      });
    }, 1);
  };

  return (
    <>
      <div className="swipe-button" style={{ '--cover-width': `${val}%` } as CSSProperties}>
        <div className="swipe-button__cover" />
        <p className="swipe-button__text">{buttonText}</p>
        <input
          type="range"
          className="swipe-button__input"
          value={val}
          onChange={handleOnChange}
          onMouseDown={clearIntervalCustom}
          onMouseUp={handleInteractionEnd}
          onTouchStart={clearIntervalCustom}
          onTouchEnd={handleInteractionEnd}
          max="100"
        />
      </div>
    </>
  );
}
